"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var folders;
        (function (folders) {
            var createOrEdit;
            (function (createOrEdit) {
                function init() {
                    addEvents();
                }
                createOrEdit.init = init;
                function addEvents() {
                    $('#Folder_IsRestricted').change(function () {
                        if ($('#Folder_IsRestricted').prop('checked'))
                            $('.folder-restricted-msg').removeClass('d-none');
                        else
                            $('.folder-restricted-msg').removeClass('d-none').addClass('d-none');
                        setSize();
                    });
                }
                function setSize() {
                    const selfHeight = $('body').outerHeight();
                    if ($('#Folder_IsRestricted').prop('checked')) {
                        appn.iframe.setModalIframeHeight();
                        $('.lockIndicator').css('opacity', 1);
                    }
                    else {
                        appn.iframe.setModalIframeHeight();
                        $('.lockIndicator').css('opacity', 0.3);
                    }
                }
            })(createOrEdit = folders.createOrEdit || (folders.createOrEdit = {}));
        })(folders = views.folders || (views.folders = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
